import {parseQueryString} from '../../utils/url'

type Value = string | null | undefined

/**
 * Return forced toggle variations from the URL search query.
 * Looks for ab_experimentId=experimentVariation, and returns an object in the form of `{ experimentId: experimentVariation }`.
 * For example ab_foo=a&ab_bar=b would yield: `{ foo: 'a', bar: 'b' }`
 */
export const getForcedTogglesFromSearchQuery = (
  url: string
): Record<string, Value> => {
  const FORCE_PREFIX = 'ab_'
  const params = parseQueryString(url)
  const result: Record<string, Value> = {}

  for (const [key, value] of Object.entries(params)) {
    if (key.startsWith(FORCE_PREFIX)) {
      const firstValue = Array.isArray(value) ? value[0] : value // Duplicate keys get turned into arrays
      result[key.slice(FORCE_PREFIX.length)] = firstValue as Value
    }
  }

  return result
}
